import { createBrowserRouter } from 'react-router-dom';
import { NotFoundPage } from './pages/NotFoundPage';
import { PublicHomePage } from './pages/PublicHomePage';
import { LazyAdminRoutes } from './routes/LazyAdminRoutes';

export const router = createBrowserRouter([
  { path: '/', element: <PublicHomePage /> },
  {
    path: '/admin/*',
    element: <LazyAdminRoutes />,
  },
  { path: '*', element: <NotFoundPage /> },
]);
